import React, { useState } from "react";
import { Button, InputNumber, Space, Typography } from "antd";
import dayjs from "dayjs";
const { Text } = Typography;

const BestSymbols = ({ cumulatedPNLList, onPeriodSelect }) => {
  // Load stored values or default
  const [topN, setTopN] = useState(() => parseInt(localStorage.getItem("ModelPerformancePage:BestSymbol:topN"), 10) || 5);
  const [period, setPeriod] = useState(() => parseInt(localStorage.getItem("ModelPerformancePage:BestSymbol:period"), 10) || 7);
  const calculateBestSymbols = (symbols, topN, period) => {
    const endTimestamp = dayjs().unix();
    const startTimestamp = dayjs().subtract(period, "days").unix();

    // Filter and adjust each symbol's data based on the new period, with starting PNL as 1
    const bestSymbols = symbols.map((symbol) => {
      // Filter data points to only include those within the specified period
      const filteredData = symbol.data.filter((point) => {
        const pointTimestamp = dayjs(point.x).unix();
        return pointTimestamp >= startTimestamp && pointTimestamp <= endTimestamp;
      });

      if (filteredData.length === 0) {
        // Handle case where there are no data points in the selected period
        return { ...symbol, data: [], performance: Number.NEGATIVE_INFINITY, visible: false };
      }

      // Adjust PNL values starting from 1
      const baselinePNL = filteredData[0].y - 1; // Adjust the initial PNL value to make it start from 1
      const adjustedData = filteredData.map((point) => ({
        ...point,
        y: point.y - baselinePNL, // Adjust PNL values relative to the new baseline
      }));

      // Calculate performance as the difference between the final and adjusted initial PNL values in the period
      const performance = adjustedData.length > 0 ? adjustedData[adjustedData.length - 1].y - 1 : Number.NEGATIVE_INFINITY;

      return { ...symbol, data: adjustedData, performance, visible: false }; // Set visibility to false initially
    });

    const topNSymbols = [...bestSymbols]
      .sort((a, b) => b.performance - a.performance)
      .slice(0, topN)
      .map((symbol) => symbol.name); // Extract names for easy lookup

    // Update visibility for top N symbols in the original order
    bestSymbols.forEach((symbol) => {
      if (topNSymbols.includes(symbol.name)) {
        symbol.visible = true; // Set top N symbols to visible
      }
    });
    return bestSymbols;
  };
  const handleShowBestSymbols = () => {
    localStorage.setItem("ModelPerformancePage:BestSymbol:topN", topN);
    localStorage.setItem("ModelPerformancePage:BestSymbol:period", period);
    const bestSymbols = calculateBestSymbols(cumulatedPNLList, topN, period);
    onPeriodSelect(bestSymbols);
  };

  return (
    <Space>
      <Text>Best N Symbols:</Text>
      <InputNumber min={1} value={topN} onChange={setTopN} style={{ width: 50 }} />
      <Text>Period (days):</Text>
      <InputNumber min={1} value={period} onChange={setPeriod} style={{ width: 50 }} />
      <Button onClick={handleShowBestSymbols}>Show Best Symbols</Button>
    </Space>
  );
};
export default BestSymbols;
